import { useTranslation } from 'react-i18next';
import { isAssigneeDeleted } from '@bliks-io/ui';

// Canonical gray-out classes live next to the other deleted-entity helpers in
// the ui package; re-exported here so frontend call sites keep one import.
export { DELETED_ENTITY_CLASS } from '@bliks-io/ui';

/**
 * Deleted-tombstone decoration for an entity rendered on a read surface.
 * Returns `isDeleted` plus the localized ` (deleted)` suffix to append to the
 * entity's display name — empty string when live, so callers can append it
 * unconditionally. Single home for the treatment shared by successor items
 * and the step card header.
 */
export function useDeletedEntity(entity: { deletedAt?: number } | null | undefined) {
  const { t } = useTranslation();
  const isDeleted = isAssigneeDeleted(entity);
  return {
    isDeleted,
    deletedSuffix: isDeleted ? ` (${t('common.deleted')})` : ''
  };
}
